export const manualAssetType = {
  国内株式: 1,
  外国株式: 2,
  投資信託: 3,
  預金_MRF: 5,
  '国内ETF・ETN': 7,
  '外国ETF・ETN': 8,
  国内REIT: 9,
  外国REIT: 10,
  信用取引: 90,
  その他: 99,
} as const;

export type ManualAssetType = typeof manualAssetType[keyof typeof manualAssetType];

export const manualAssetTypes = [
  {
    id: manualAssetType.国内株式,
    title: '国内株式',
  },
  {
    id: manualAssetType.外国株式,
    title: '外国株式',
  },
  {
    id: manualAssetType.投資信託,
    title: '投資信託',
  },
  {
    id: manualAssetType['国内ETF・ETN'],
    title: '国内ETF・ETN',
  },
  {
    id: manualAssetType['外国ETF・ETN'],
    title: '外国ETF・ETN',
  },
  {
    id: manualAssetType.国内REIT,
    title: '国内REIT',
  },
  {
    id: manualAssetType.外国REIT,
    title: '外国REIT',
  },
  {
    id: manualAssetType.信用取引,
    title: '信用取引',
  },
  {
    id: manualAssetType.預金_MRF,
    title: '現金・MRF',
  },
  {
    id: manualAssetType.その他,
    title: 'その他',
  },
];
